import React, { FC } from 'react'
import { TheatricalShowtime } from '@/types/codegen-federation'
import { ShowtimesVenue } from '../../hooks/useVenueSearch/useVenueSearch'
import { SeatAvailabilityDrawer } from './SeatAvailabilityDrawer'

interface SeatAvailabilityProps {
  isOpen: boolean
  onClose: () => void
  venue: ShowtimesVenue
  showtimes: TheatricalShowtime[]
  onShowtimeClick: (showtime: TheatricalShowtime) => void
}

export const SeatAvailability: FC<SeatAvailabilityProps> = ({ isOpen, onClose, venue, showtimes, onShowtimeClick }) => {
  return (
    <SeatAvailabilityDrawer
      isOpen={isOpen}
      onClose={onClose}
      venue={venue}
      showtimes={showtimes}
      onShowtimeClick={onShowtimeClick}
    />
  )
}
